module.exports = __webpack_public_path__ + "static/media/img4.96ec043e.jpg";